import React from 'react';
import { User, Incoterm } from '../../../types';

const AuthUserContext = React.createContext<{
  authUser: Partial<User> & Pick<User, 'constants'>;
  incoterms: Incoterm[];
  updateTableSortOptions: () => void;
  updateUserSettings: (settings: any) => void;
}>({
  authUser: {
    constants: {
      days: [],
      modes: [],
      movementTypes: [],
      airRateBreaks: [],
      frequencies: [],
      quantityTypes: [],
      rateTypes: [],
      chargeUnitNames: [],
      chargeCategories: [],
      chargeTypes: [],
      containerRateTypes: [],
    },
  },
  incoterms: [],
  updateTableSortOptions: () => {},
  updateUserSettings: (settings) => {},
});

export default AuthUserContext;
